import { Content, Footer, Header, RouterContext, TripleAction } from '../../gs-component-right-rail';
import { FormikProps } from 'formik';
import React, { useContext } from 'react';

import { ApiClientsContext } from '../components/ApiClientsContext';
import { useBookingsAddressLegacy } from '../helpers/useBookingsAddressLegacy';
import EventForm from './EventForm';
import { FormValues } from './RightRailForm';

interface Props {
  formProps: FormikProps<FormValues>;
  isNew: boolean;
  hasWWS: boolean;
  setClose: (value: boolean) => void;
  loading: boolean;
}

export const RightRailContent: React.FC<Props> = ({ formProps, isNew, hasWWS, setClose, loading }) => {
  const headerName = isNew ? 'Add New Event' : 'Edit Event';
  const { gdsEvent: events, eventType } = useContext(ApiClientsContext);
  const { push } = useContext(RouterContext);
  useBookingsAddressLegacy({
    setFieldValue: formProps.setFieldValue,
    values: formProps.values,
    eventType,
  });

  const onRailClose = (): void => {
    if (formProps.dirty) {
      push('confirmation');
    } else {
      setClose(false);
      formProps.resetForm();
    }
  };

  const removeEvent = (): void => {
    if (events && !Array.isArray(events)) {
      push('delete');
    }
  };

  return (
    <>
      <Header onClose={onRailClose}>{headerName}</Header>
      <Content>
        <EventForm hasWWS={hasWWS} {...formProps} />
      </Content>
      <Footer>
        <TripleAction
          primaryText="Save"
          primaryOnClick={formProps.submitForm}
          primaryDisabled={loading}
          secondaryText="Cancel"
          secondaryOnClick={onRailClose}
          tertiaryText={!isNew && eventType !== 'Ceremony' ? 'Remove Event' : undefined}
          tertiaryOnClick={removeEvent}
        />
      </Footer>
    </>
  );
};
